export default __webpack_public_path__ + "static/media/logo.59c1c0ba.svg";